import {
  RestaurantEventAddOn,
  RestaurantEventDisclaimer,
} from './restaurantEvents';
import { Shift } from './shifts';

export enum RestaurantStatus {
  Active = 'active',
  Archived = 'archived',
  ComingSoon = 'coming_soon',
}

export type RestaurantEventTier = {
  id: string;
  name: string;
  description: string | null;
  capacity: number;
  price: number;
  floorPlanTableIds: string[];
  ticketsSold: number;
};

export interface RestaurantEventServiceFee {
  id: string;
  label: string;
  percentage: number;
}

export type BookingUnit = 'seat' | 'table';

export type GuestEmailRequirement = 'hidden' | 'optional' | 'required';

export interface RestaurantEvent {
  id: string;
  name: string;
  description: string;
  location: string | null;
  directions: string | null;
  customConfirmationMessage: string | null;
  includeTicketsLinkInConfirmation: boolean;
  bookingUnit: BookingUnit;
  guestEmailRequirement: GuestEmailRequirement;
  isDeleted: boolean;
  serviceChargePercentage: number;
  capacity: number;
  /**
   * The part of the event's public URL after `/events/`. Stored when the event
   * is created and never changed by edits: a name-only slug, or `slug/dd-MM-yyyy`
   * for events that predate name-only URLs. `null` for events that have none
   * stored, which fall back to the name + date URL.
   */
  urlSlug: string | null;
  shift: Shift;
  images: RestaurantEventImage[];
  disclaimers: RestaurantEventDisclaimer[];
  serviceFees?: RestaurantEventServiceFee[];
  tiers: RestaurantEventTier[];
  addOns: RestaurantEventAddOn[];
}

export interface RestaurantEventImage {
  id: string;
  imageKey: string;
}

export interface RestaurantMetadata {
  id: string;
  name: string;
  street: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface ServiceFeePayload {
  label: string;
  percentage: number;
}
